export default function Visa(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={48} height={24} {...props}>
      <path
        d="M20.821 19.34h-3.95l2.47-15.063h3.949ZM34.962 4.641a9.85 9.85 0 0 0-3.543-.642c-3.9 0-6.647 2.052-6.664 4.986-.032 2.164 1.966 3.367 3.461 4.088 1.528.737 2.048 1.219 2.048 1.876-.016 1.01-1.235 1.475-2.372 1.475a7.95 7.95 0 0 1-3.706-.8l-.52-.241-.553 3.383a12.166 12.166 0 0 0 4.4.8c4.144 0 6.842-2.02 6.874-5.146.016-1.715-1.04-3.03-3.315-4.1-1.381-.69-2.227-1.154-2.227-1.86.016-.641.716-1.3 2.275-1.3a6.788 6.788 0 0 1 2.942.577l.357.16.537-3.254ZM39.939 14.004c.325-.865 1.577-4.214 1.577-4.214-.016.032.325-.881.52-1.442l.276 1.3s.748 3.606.91 4.359Zm4.875-9.727h-3.055a1.951 1.951 0 0 0-2.064 1.25L33.828 19.34h4.144l.829-2.26h5.071c.113.529.471 2.26.471 2.26H48L44.814 4.277ZM13.879 4.277 10.011 14.55l-.423-2.083a11.573 11.573 0 0 0-5.461-6.314L7.67 19.325h4.177l6.208-15.047Z"
        fill="#00579f"
      />
      <path
        d="M6.419 4.277H.065L0 4.586c4.957 1.268 8.24 4.323 9.589 8l-1.381-7.02A1.634 1.634 0 0 0 6.42 4.282Z"
        fill="#faa61a"
      />
    </svg>
  );
}
